import { Tag } from 'antd';
import moment from 'moment'

function onClickEvent (status, activate, cancel, record) {
  // 未激活
  if (status === 0) {
    activate(record);
  } else {
    cancel(record); 
  }
}

function createColumns (activate, cancel) {
  
  const columns = [
    {
      title: 'name',
      render (data) {
        const url = `https://admin.shopify.com/store/tenways10/orders/${data['orderId']}`;
        return <a href={url}>{data['name']}</a>
      }
    },
    {
      title: 'Country',
      dataIndex: 'country',
    },
    {
      title: 'Email',
      dataIndex: 'contactEmail'
    },
    {
      title: 'userName',
      dataIndex: 'userName'
    },
    {
      title: 'update time',
      dataIndex: 'updatedAt',
      render: (data) => {
        return moment(data).format('YYYY-MM-DD HH:mm:hh')
      }
    },
    {
      title: 'Status',
      dataIndex: 'status',
      render: (status) => {
        if (status === '0' || status === 0) {
          return <Tag color='#87d068'>normal</Tag>
          
        } else if (status === '1' || status === 1) {
          return <Tag color='#2db7f5'>out of area</Tag>
        } else {
          return <Tag color='#f50'>Error</Tag>
        }
      }
    },
    {
      title: 'state',
      dataIndex: 'state',
      render: (status) => {
        if (status === '0' || status === 0) {
          return <Tag color='#108ee9'>pending</Tag>
        } else if (status === '1' || status === 1) {
          return <Tag color='#2db7f5'>qoute</Tag>
        } else {
          return <Tag color='#87d068'>handoff</Tag>
        }
      }
    }
  ];
  return columns;
}

export default createColumns;